<template>
  <v-timeline-item class="logs-timeline" small fill-dot color="#1c6cab" :icon="getIcon">
    <v-row class="pt-0">
      <v-col v-if="task.logType === 'mannualLog'" class="pl-0" cols="12">
        <div class="d-flex justify-space-between">
          <div>
            <p class="dark--text font-weight-medium mb-0">{{ getSubject(task.subject) }}</p>
            <p class="text-xs dark--text mb-0 ml-3">
              {{ task.created_by }} logged a call with
              <v-tooltip top content-class="log-tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span v-if="task.contact_details" v-bind="attrs" class="info--text" v-on="on">{{
                    task.contact_details.name
                      ? task.contact_details.name
                      : task.contact_details.email
                  }}</span>
                </template>
                <div v-if="task.contact_related_type === 'leads'">
                  <div class="d-flex mb-1">
                    <p class="mb-0">Title -</p>
                    <p class="mb-0">{{ task.contact_details.title }}</p>
                  </div>
                  <div class="d-flex">
                    <p class="mb-0">Source -</p>
                    <p class="mb-0">{{ task.contact_details.source }}</p>
                  </div>
                </div>
                <div v-else>
                  <h3 class="mb-2">{{ task.contact_details.name }}</h3>

                  <div class="d-flex mb-1">
                    <p class="mb-0">Email -</p>
                    <p class="mb-0">{{ task.contact_details.email }}</p>
                  </div>
                  <div class="d-flex">
                    <p class="mb-0">Phone -</p>
                    <p class="mb-0">{{ task.contact_details.phone }}</p>
                  </div>
                </div>
              </v-tooltip>
            </p>
          </div>

          <div class="action-icons">
            <v-icon size="18" class="cursor-pointer" @click="editCallLogs(task)">
              {{ icons.mdiPencil }}
            </v-icon>
            <v-icon size="18" class="cursor-pointer" @click="deleteTask(task.uuid)">
              {{ icons.mdiDelete }}
            </v-icon>
          </div>
        </div>

        <div class="d-flex align-center ml-3">
          <v-icon v-if="!isVisible" @click="isVisible = true">
            {{ icons.mdiChevronRight }}
          </v-icon>
          <v-icon v-else @click="isVisible = false">
            {{ icons.mdiChevronDown }}
          </v-icon>
          <p class="mb-0 ml-1 text-xs2 text--primary">
            <span class="text-xs dark--text">{{ formatDate(task.date) }}</span>
          </p>
        </div>
        <div v-if="isVisible" class="log-card mt-1 ml-3">
          <p class="dark--text text-sm mb-1">{{ task.comment }}</p>
        </div>
      </v-col>
      <v-col v-else-if="task.logType === 'task'" class="pl-0" cols="12">
        <v-row>
          <v-col cols="12">
            <div>
              <div class="text-link mr-5" @click="handleTaskClick(task.uuid)">
                {{ task.name }}
              </div>
              <div>
                <span class="text-xs dark--text">
                  <span v-for="(user, i) in task.assigned_users" :key="user.uuid"
                    >{{ user.name }}<span v-if="i + 1 !== task.assigned_users.length">, </span>
                  </span>
                  had a task</span
                >
                <span v-if="task.contact_detail && task.contact_detail.uuid" class="text-xs">
                  with

                  <v-tooltip top content-class="log-tooltip">
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-if="task.contact_detail && task.contact_detail.uuid"
                        v-bind="attrs"
                        class="info--text"
                        v-on="on"
                        >{{ task.contact_detail.name }}</span
                      >
                    </template>
                    <div>
                      <h3 class="mb-2">{{ task.contact_detail.name }}</h3>

                      <div class="d-flex mb-1">
                        <p class="mb-0">Email -</p>
                        <p class="mb-0">{{ task.contact_detail.email }}</p>
                      </div>
                      <div class="d-flex">
                        <p class="mb-0">Phone -</p>
                        <p class="mb-0">{{ task.contact_detail.phone }}</p>
                      </div>
                    </div>
                  </v-tooltip>
                </span>

                <span
                  v-if="task.related_to && $route.params.uuid !== task.related_to.uuid"
                  class="text-xs"
                  @click="handleRedirect(task)"
                >
                  about <span class="text-link">{{ task.related_to.name }}</span>
                </span>
              </div>
            </div>

            <div class="d-flex align-center">
              <v-icon v-if="!isVisible" @click="isVisible = true">
                {{ icons.mdiChevronRight }}
              </v-icon>
              <v-icon v-else @click="isVisible = false">
                {{ icons.mdiChevronDown }}
              </v-icon>
              <p class="mb-0 ml-2 text-xs2 text--primary">
                <span class="text-xs dark--text">{{ formatDate(task.updatedAt) }}</span>
              </p>
            </div>
            <div v-if="isVisible" class="log-card mt-2">
              <p class="dark--text text-sm mb-1" style="white-space: pre-wrap">
                {{ task.details }}
              </p>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col v-else class="pl-0">
        <div cols="12">
          <div class="">
            <div class="dark--text font-weight-medium mr-5">
              {{ 'Email -' + task.subject }}
            </div>
            <div v-if="task.from[0].name" class="dark--text text-xs ml-3">
              {{ task.from[0].name }} send an email to {{ task.to[0].name }}
            </div>
          </div>

          <div class="d-flex align-center ml-3">
            <v-icon v-if="!isVisible" @click="isVisible = true">
              {{ icons.mdiChevronRight }}
            </v-icon>
            <v-icon v-else @click="isVisible = false">
              {{ icons.mdiChevronDown }}
            </v-icon>
            <p class="mb-0 ml-2 text-xs2 text--primary">
              <span class="text-xs dark--text">{{ formatDate(task.updatedAt) }}</span>
            </p>
          </div>
          <div v-if="isVisible" class="log-card mt-2 ml-3">
            <div v-if="task && task.from.length" class="d-flex align-center">
              <v-avatar size="38" class="me-3">
                <v-img :src="require('@/assets/images/avatars/1.png')"></v-img>
              </v-avatar>
              <div class="d-flex justify-center flex-column">
                <span class="text--primary font-weight-medium text-sm">{{
                  task.from[0].name
                }}</span>
                <span class="text-xs3">{{ task.from[0].email }}</span>
              </div>
            </div>

            <div class="message-content mt-2 mb-1" v-html="task.body"></div>
          </div>
        </div>
      </v-col>
      <EditCallLog
        v-if="openEditLogModal"
        :contact-array="contactArray"
        :modal-form="logForm"
        :open-log-modal="openEditLogModal"
        @fetchContacts="$emit('fetchContacts', $event)"
        @fetchRecords="$emit('fetchRecords')"
        @close="openEditLogModal = false"
      />
    </v-row>
  </v-timeline-item>
</template>
<script>
import { ref, computed } from '@vue/composition-api'
import {
  mdiChevronRight,
  mdiChevronDown,
  mdiDelete,
  mdiPhone,
  mdiEmail,
  mdiStar,
  mdiTextBox,
  mdiPencil,
} from '@mdi/js'
import Toaster from '@core/utils/sweetToast'
import { storeActions } from '@/store/storeConstants'
import store from '@/store'
import { formatDate } from '@core/utils/filter'
import moment from 'moment'
import { useRouter } from '@core/utils'

import { isCrmSection, getRouteView } from '@core/utils/common'
import useTabService from '@/@core/comp-functions/useTabService'
import EditCallLog from './EditCallLog.vue'

export default {
  components: { EditCallLog },
  props: {
    task: {
      type: Object,
      default: () => ({}),
    },
    modalForm: {
      type: Object,
      default: undefined,
    },
    contactArray: {
      type: Array,
      default: () => [],
    },
  },

  setup(props, { emit }) {
    const { router } = useRouter()

    const isVisible = ref(false)
    const openEditLogModal = ref(false)
    const isSHow = ref(true)
    const logForm = ref({})
    const { DELETE_BY_ID } = storeActions
    const panel = ref(null)
    const { gotoCrmTab } = useTabService()

    const subjectList = ref([
      { text: 'Call', value: 0 },
      { text: 'Email', value: 1 },
      { text: 'Send Letter', value: 2 },
      { text: 'Send Quote', value: 3 },
      { text: 'Meeting', value: 5 },
      { text: 'Other', value: 4 },
    ])

    const getIcon = computed(() => {
      if (props.task.logType === 'email') {
        return mdiEmail
      }
      if (props.task.logType === 'task') {
        return mdiTextBox
      }

      return mdiPhone
    })

    const getSubject = id => {
      const sub = subjectList.value.find(opt => {
        return opt.value === id
      })

      if (sub) {
        return sub.text
      }

      return ''
    }
    const deleteTask = id => {
      Toaster.confirmation("You won't be able to revert this.").then(resp => {
        const config = {
          component: 'task-management/logs',
          objectId: id,
        }
        if (resp.isConfirmed) {
          store
            .dispatch(`common/${DELETE_BY_ID}`, config)
            .then(({ data }) => {
              if (data.success) {
                emit('fetchRecords')
                Toaster.success(data.message)
              } else {
                Toaster.error(data.message, 'warning')
              }
            })
            .catch(() => {
              Toaster.error('An error occur, please try again later', 'warning')
            })
        }
      })
    }

    const editCallLogs = value => {
      logForm.value = value
      openEditLogModal.value = true
    }

    const handleTaskClick = uuid => {
      store.commit('taskManagement/SET_TASKBAR_ID', uuid)
      store.commit('taskManagement/SET_OPEN_BAR', true)
    }

    const handleRedirect = item => {
      const payload = {
        paramName: 'uuid',
        name: item.related_to.name,
        uuid: item.related_to.uuid,
      }

      if (isCrmSection(item.related_type)) {
        gotoCrmTab(payload, getRouteView(item.related_type))

        router.push({ name: getRouteView(item.related_type), params: { uuid: payload.uuid } })
      }
    }

    return {
      isVisible,
      isSHow,
      getSubject,
      deleteTask,
      handleRedirect,
      formatDate,
      editCallLogs,
      handleTaskClick,
      logForm,
      openEditLogModal,
      getIcon,
      panel,
      moment,
      icons: {
        mdiPencil,
        mdiChevronRight,
        mdiChevronDown,
        mdiDelete,
        mdiEmail,
        mdiStar,
      },
    }
  },
}
</script>

<style scoped lang="scss">
.log-card {
  border: thin solid rgb(222, 222, 222);
  padding: 10px;
  border-radius: 5px;
}
.collapse-bar {
  background: #eee;
  min-height: 40px !important;
}
.message-content > div ~ div,
br {
  display: none !important;
}

.message-content hr {
  display: none !important;
}
</style>
<style lang="scss">
.v-timeline-item.logs-timeline {
  .v-timeline-item__dot {
    border-radius: 8%;
    .v-timeline-item__inner-dot {
      border-radius: 8%;

      .v-icon__svg {
        fill: white;
      }
    }
  }
}
.action-icons {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  min-width: 48px;
  margin-top: 2px;
}
</style>
